import React, { Component } from 'react';

class IconContactCalendar extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="120" height="133.333" viewBox="0 0 120 133.333"><path className="a" d="M111.167,14.833H104.5V1.5H91.167V14.833H37.833V1.5H24.5V14.833H17.833A13.33,13.33,0,0,0,4.5,28.167V121.5a13.33,13.33,0,0,0,13.333,13.333h93.333A13.373,13.373,0,0,0,124.5,121.5V28.167A13.373,13.373,0,0,0,111.167,14.833Zm-46.667,20a20,20,0,1,1-20,20A19.973,19.973,0,0,1,64.5,34.833Zm40,80h-80v-6.667c0-13.333,26.667-20.667,40-20.667s40,7.333,40,20.667Z" transform="translate(-4.5 -1.5)" fill="#1d53a5" opacity="0.2" /></svg>
        );
    }
}

export default IconContactCalendar;